import React from "react";
import { Provider } from "react-redux";
import store from "./redux/store";
import App from "./components/App";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { SW_INIT, SW_UPDATE } from "./redux/constants/pwa";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { createRoot } from "react-dom/client";
// import {initializeFirebase} from "./utils/push-notification";
// import "@fortawesome/fontawesome-free/css/all.min.css";

function AppWithCallbackAfterRender() {
  return <App />;
}
const root = createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID}>
      <AppWithCallbackAfterRender />
    </GoogleOAuthProvider>
  </Provider>
);

// initializeFirebase();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register({
  onSuccess: () => store.dispatch({ type: SW_INIT }), // Page has been saved for offline use.
  onUpdate: (reg) => store.dispatch({ type: SW_UPDATE, payload: reg }), // Click to get the latest version.
});
